var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHuman2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 0.833008C9.16675 0.833008 4.16675 4.16634 1.66675 9.16634C5.00008 12.6663 9.83341 14.6663 15.0001 14.6663C20.1667 14.6663 25.0001 12.4997 28.3334 9.16634C25.8334 4.33301 20.8334 0.833008 15.0001 0.833008Z",
    stroke: "#414141",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman2);
export default __webpack_public_path__ + "static/media/human2.3f874fa310c8f57f47a6f3e56b42f5dd.svg";
export { ForwardRef as ReactComponent };